import { render, staticRenderFns } from "./selectPage.vue?vue&type=template&id=18fc9adc&scoped=true"
import script from "./selectPage.vue?vue&type=script&lang=js"
export * from "./selectPage.vue?vue&type=script&lang=js"
import style0 from "./selectPage.vue?vue&type=style&index=0&id=18fc9adc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fc9adc",
  null
  
)

export default component.exports